// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"94315750","455":"336173ec","977":"0b119a51"}[chunkId] + ".chunk.js";
};